import React, { useContext, useEffect, useState } from "react";
import "../../styles/pages/Editor.scss";
//import FroalaEditorComponent from 'react-froala-wysiwyg';
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.css";
import "froala-editor/js/plugins.pkgd.min.js";
import ValueContext from "../../ContextAPi/appContext";
import ExportHeader from "../BannerManager/ExportHeader";
import { toast } from "react-toastify";
export default function ExportCenterContainer({
  exportDOMData,
  setType,
  type,
  setLoading,
  checkExportType,
  setCheckExportType,
  rvcvTypes,
  setRvcvTypes,
  setHtmlContent,
  backupFallback
}) {
  let layerLink = "";
  const appData = useContext(ValueContext);
  const [fontLink, setFontLink] = useState("");
  const [canvasDom, setCanvasDom] = React.useState([]);
  const [animationObj, setAnimationObj] = React.useState([]);
  const [animationObjNew, setAnimationObjNew] = React.useState({});
  const [animationObjNewStrigified, setAnimationObjNewStrigified] =
    React.useState({});
  function reRender(data) {
    let layerCompData = [],
      animationObj = [];
    let animationObjNew = {};

    let sample = [];

    let Id;

    data.forEach((data, index) => {
      Id = data.componentType + index;
      let shapeType =
        data.components.textComponentType?.addContent === "triangleShape"
          ? "triImage"
          : data.components.textComponentType?.addContent === "polygonShape"
            ? "pentImage"
            : data.components.textComponentType?.addContent === "hexagonShape"
              ? "hexImage"
              : "";
      layerCompData.push({
        id: data.componentType + index,
        componentType: data.componentType,
        froalaText: data.components.froalaText,
        componentStyles: data.components,
        textComponentType: data.components.textComponentType,
        scrollbarComponents: data.components?.scrollbarComponents,
        [shapeType]: data.components.src,
      });

      let animationObjectNew = JSON.parse(
        JSON.stringify(data.components.animationObj || []),
      );
      // Object.values(animationObjectNew.animation).forEach((obj) => {
      let obj = animationObjectNew.animation || [];
      // Commented out: do not add a default keyframe at 0s.
      // if (obj.length > 0 && obj[0].delay !== 0) {
      //   let tempObj = obj[0];
      //   if (tempObj) {
      //     tempObj.delay = 0;
      //
      //     tempObj.duration = tempObj?.end;
      //     let firstObject = {
      //       ...tempObj,
      //       rotation: 0,
      //       left: 0,
      //       top: 0,
      //       width: tempObj.width,
      //       height: tempObj.height,
      //       transform: 1,
      //       delay: 0,
      //       duration: 0,
      //       ease: "NONE",
      //       end: 0,
      //       opacity: 1,
      //     };
      //     obj.splice(0, 0, firstObject);
      //     obj[1] = tempObj;
      //   }
      // }
      // });

      obj.forEach((eachAnimation) => {
        const animationData = {
          api: "to",
          atoms: [Id],
          duration: eachAnimation.duration,
          op: {
            delay: eachAnimation.delay,
            opacity: eachAnimation.opacity,
            ease: eachAnimation.ease,
            rotation: eachAnimation.rotation,
            rotationX: eachAnimation.rotationX,
            rotationY: eachAnimation.rotationY,
            scale: eachAnimation.transform,
            left: 0,
            top: 0,
            transform: `translate(${(eachAnimation.x || 0) + (eachAnimation.translateX || 0)}px,${(eachAnimation.y || 0) + (eachAnimation.translateY || 0)}px)`,
            width: eachAnimation?.width,
            height: eachAnimation?.height,
            transformOrigin: `${eachAnimation.transformOriginX}% ${eachAnimation.transformOriginY}% ${eachAnimation.transformOriginZ}px`,
            backgroundSize: `${eachAnimation.width}px ${eachAnimation.height}px`,
          },
        };

        animationObj.push(animationData);
      });
      let compAnmObj = data.components.animationObj;
      animationObjNew = { ...animationObjNew, [Id]: compAnmObj };
    });
    setAnimationObjNew(animationObjNew);
    setAnimationObjNewStrigified(JSON.stringify(animationObjNew));
    setCanvasDom(layerCompData);
    setAnimationObj(animationObj);
    //console.log(layerCompData, "layerCompData", animationObj);
  }
  // React.useEffect(() => {
  //   let tempfontLink = "";
  //   let components = exportDOMData.cards?.assetpages[0]?.assetpagecomponent;
  //   if (components.length > 0) {
  //     components.forEach((component) => {
  //       tempfontLink += `${component.components.fontLink} \n`;
  //     });
  //   }
  //   setFontLink(tempfontLink);
  // }, []);
  function buildExportData(components = []) {
    const layerCompData = [];
    const animationObj = [];
    let animationObjNew = {};

    components.forEach((data, index) => {
      const Id = data.componentType + index;

      const shapeType =
        data.components.textComponentType?.addContent === "triangleShape"
          ? "triImage"
          : data.components.textComponentType?.addContent === "polygonShape"
            ? "pentImage"
            : data.components.textComponentType?.addContent === "hexagonShape"
              ? "hexImage"
              : "";

      layerCompData.push({
        id: Id,
        componentType: data.componentType,
        froalaText: data.components.froalaText,
        componentStyles: data.components,
        textComponentType: data.components.textComponentType,
        scrollbarComponents: data.components?.scrollbarComponents,
        [shapeType]: data.components.src,
      });

      // your existing animation normalization
      let animationObjectNew = JSON.parse(
        JSON.stringify(data.components.animationObj || []),
      );

      let obj = animationObjectNew.animation || [];
      // Commented out: do not add a default keyframe at 0s.
      // if (obj.length > 0 && obj[0].delay !== 0) {
      //   let tempObj = obj[0];
      //   tempObj.delay = 0;
      //   tempObj.duration = tempObj?.end;
      //
      //   const firstObject = {
      //     ...tempObj,
      //     rotation: 0,
      //     left: 0,
      //     top: 0,
      //     width: tempObj.width,
      //     height: tempObj.height,
      //     transform: 1,
      //     delay: 0,
      //     duration: 0,
      //     ease: "NONE",
      //     end: 0,
      //     opacity: 1,
      //   };
      //   obj.splice(0, 0, firstObject);
      //   obj[1] = tempObj;
      // }

      obj.forEach((eachAnimation) => {
        animationObj.push({
          api: "to",
          atoms: [Id],
          duration: eachAnimation.duration,
          op: {
            delay: eachAnimation.delay,
            opacity: eachAnimation.opacity,
            ease: eachAnimation.ease,
            rotation: eachAnimation.rotation,
            rotationX: eachAnimation.rotationX,
            rotationY: eachAnimation.rotationY,
            scale: eachAnimation.transform,
            left: 0,
            top: 0,
            transform: `translate(${(eachAnimation.x || 0) + (eachAnimation.translateX || 0)}px,${(eachAnimation.y || 0) + (eachAnimation.translateY || 0)}px)`,
            width: eachAnimation?.width,
            height: eachAnimation?.height,
            transformOrigin: `${eachAnimation.transformOriginX}% ${eachAnimation.transformOriginY}% ${eachAnimation.transformOriginZ}px`,
            backgroundSize: `${eachAnimation.width}px ${eachAnimation.height}px`,
          },
        });
      });

      animationObjNew = {
        ...animationObjNew,
        [Id]: data.components.animationObj,
      };
    });

    return { layerCompData, animationObj, animationObjNew };
  }

  const renderTheFontLink = (fontFamily) => {
    if (fontFamily.startsWith(" ")) fontFamily = fontFamily.substring(1);
    let tempFont = fontFamily?.split(" ").join("+");
    let url = `https://fonts.googleapis.com/css2?family=${tempFont}:wght@100;200;300;400;500;600;700;800;900&display=swap`;
    var link = document.createElement("link");
    link.href = url;
    link.rel = "stylesheet";
    link.type = "text/css";
    document.getElementsByTagName("head")[0].appendChild(link);
    return `<link rel=${"stylesheet"} href= "${url}">`;
  };
  var stringToHTML = function (str) {
    var dom = document.createElement("div");

    dom.innerHTML = str;

    return dom;
  };

  const renderAppliedFonts = (layers) => {
    const customFonts = appData?.savedCustomFontList
    const customFontNames = customFonts.map((font) => font.familyName)

    if (!Array.isArray(layers) || layers.length === 0) return "";

    const SYSTEM_FONTS = new Set(
      ["Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana"].map((f) =>
        f.toLowerCase(),
      ),
    );

    const normalizeFont = (f) => {
      if (customFontNames.includes(f)) return null
      if (!f) return null;
      let first = String(f).split(",")[0].trim(); // take first before fallback list
      first = first.replace(/^["']|["']$/g, ""); // remove quotes
      if (!first) return null;
      if (SYSTEM_FONTS.has(first.toLowerCase())) return null;
      return first;
    };

    const fonts = new Set();

    // 1) from componentStyles.fontFamily (Text/Button)
    layers.forEach((layer) => {
      if (
        layer?.componentType === "Button" ||
        layer?.componentType === "Text"
      ) {
        const ff = normalizeFont(layer?.componentStyles?.fontFamily);
        if (ff) fonts.add(ff);
      }
    });

    // 2) from Froala spans (if any)
    layers.forEach((layer) => {
      if (!layer?.froalaText) return;
      const dom = document.createElement("div");
      dom.innerHTML = layer.froalaText;

      const spans = dom.getElementsByTagName("span");
      for (let i = 0; i < spans.length; i++) {
        const ff = normalizeFont(spans[i]?.style?.fontFamily);
        if (ff) fonts.add(ff);
      }
    });

    if (fonts.size === 0) return "";

    // return multiple link tags (simple + reliable)
    return Array.from(fonts)
      .map((font) => renderTheFontLink(font))
      .join("\n");
  };
  React.useEffect(() => {
    const comps =
      exportDOMData?.cards?.assetpages?.[0]?.assetpagecomponent || [];

    if (comps.length > 0) {
      const { layerCompData, animationObj, animationObjNew } =
        buildExportData(comps);

      // ✅ IMPORTANT: pass the array you built (layerCompData), NOT exportDOMData.cards
      const links = renderAppliedFonts(layerCompData);

      setFontLink(links);
      setCanvasDom(layerCompData);
      setAnimationObj(animationObj);
      setAnimationObjNew(animationObjNew);
      setAnimationObjNewStrigified(JSON.stringify(animationObjNew));
    } else {
      setLoading(false);
      toast.error(<div className="notificationText">Banner is Empty!</div>);
    }
  }, [exportDOMData]);

  return (
    <>
      <div
        id="canvas-page-export"
        style={{
          width: exportDOMData.cards.width + "px",
          height: exportDOMData.cards.height + "px",
        }}
      ></div>
      {canvasDom.length > 0 && (
        <ExportHeader
          anmObj={animationObjNew}
          setHtmlContent={setHtmlContent}
          animationObjecStringified={animationObjNewStrigified}
          type={type}
          setType={setType}
          setLoading={setLoading}
          canvasDimension={{
            width: exportDOMData.cards.width,
            height: exportDOMData.cards.height,
            bgColorCanvas: exportDOMData.cards?.attributes?.backgroundColor,
            fps: exportDOMData.cards?.attributes?.fps,
            globalLink: exportDOMData.cards?.attributes?.globalLink,
            checkGloballink: exportDOMData?.cards?.attributes?.checkGloballink,
            checkLoops: exportDOMData?.cards?.attributes?.checkLoops,
            loopAnimation: exportDOMData?.cards?.attributes?.loopAnimation,
            custom: exportDOMData?.cards?.attributes?.custom,
          }}
          canvasDom={canvasDom}
          animationObj={animationObj}
          fontLink={fontLink}
          checkExportType={checkExportType}
          setCheckExportType={setCheckExportType}
          rvcvTypes={rvcvTypes}
          setRvcvTypes={setRvcvTypes}
          backupFallback={backupFallback}
        />
      )}
    </>
  );
}
